__webpack_require__.p = "https://app.veerajgroup.com/";